export type Consent = {
  necessary: true;          // immer true
  analytics: boolean;       // durch Nutzerwahl
  timestamp?: string;
};

const KEY = "svevana.consent.v1";

export function readConsent(): Consent | null {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as Consent) : null;
  } catch {
    return null;
  }
}

export function writeConsent(c: Consent) {
  localStorage.setItem(KEY, JSON.stringify(c));
  window.dispatchEvent(new CustomEvent<Consent>("cookie-consent:change", { detail: c }));
}

export function hasAnswered(): boolean {
  return !!readConsent();
}

// UI aus beliebigen Stellen öffnen (z. B. Footer)
export function openConsentSettings() {
  window.dispatchEvent(new Event("cookie-consent:open"));
}
